module.exports = __webpack_public_path__ + "static/media/close_bug.d28f8c28.svg";